import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type LifecycleKind = 'draft' | 'ready' | 'active' | 'deprecated';

@Component({
  selector: 'app-lifecycle-pill',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="lifecycle-pill" [attr.data-kind]="kind()" data-testid="lifecycle-pill">
      <span class="lifecycle-pill__dot" aria-hidden="true"></span>
      {{ label() }}
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
    }

    .lifecycle-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.4375rem;
      padding: 0.3125rem 0.6875rem;
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 600;
      white-space: nowrap;
      background: var(--to-slate-bg);
      color: var(--to-slate-fg);

      &[data-kind='ready'] {
        background: var(--to-blue-bg);
        color: var(--to-blue-fg);
      }
      &[data-kind='active'] {
        background: var(--to-green-bg);
        color: var(--to-green-fg);
      }
      &[data-kind='deprecated'] {
        background: var(--to-warn-bg);
        color: var(--to-warn-fg);
      }
    }

    .lifecycle-pill__dot {
      width: 0.375rem;
      height: 0.375rem;
      border-radius: 50%;
      flex-shrink: 0;
      background: var(--to-slate-dot);

      .lifecycle-pill[data-kind='ready'] & {
        background: var(--to-blue-dot);
      }
      .lifecycle-pill[data-kind='active'] & {
        background: var(--to-green-dot);
      }
      .lifecycle-pill[data-kind='deprecated'] & {
        background: var(--to-amber-deep);
      }
    }
  `,
})
export class LifecyclePillComponent {
  readonly kind = input.required<LifecycleKind>();
  readonly label = input.required<string>();
}
